/**
 * Production environment settings
 *
 * This file is where you define overrides for any of the config settings that
 * should only be applied in the production environment.
 *
 * The production environment is defined as 'process.env.LORE_ENV=production' and
 * is automatically set when webpack is invoked using the --env.lore=production argument.
 */

export default {

  /**
   * To override a config setting, specify the name of the config file you
   * want to override, followed by the settings you want to change.
   */

  auth0: {
    clientID: '97v6t0JM9UWXQxkSuhep0exSMikrzuAO', // Auth0 application = CommunityShare SPA
    domain: 'auth.communityshare.org',
    redirectUri: `https://steward.communityshare.org/auth/callback`,
    skipAuth0: false
  },

  connections: {
    default: {
      apiRoot: 'https://api.communityshare.org/steward_v2'
    },
    community: {
      apiRoot: 'https://api.communityshare.org/community_v3'
    }
  },

  custom: {
    platformUrl: function() {
      return `https://app.communityshare.org`;
    }
  },

  google: {
    enabled: true
  },

  intercom: {
    companyId: 'production-admin',
    companyName: 'Production (Admin)'
  },

  raven: {
    environment: 'production-admin',
    enabled: true
  },

  fullstory: {
    enabled: true
  },

  dialogs: {
    showTransitions: true
  },

  flags: {
    grayscale: false
  },

  statsig: {
    environment: 'production'
  }
}
